// firebaseConfig.js
// Import the functions you need from the SDKs you need
import { initializeApp, getApps, getApp } from 'firebase/app';
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  indexedDBLocalPersistence,
  inMemoryPersistence,
} from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

// Your web app's Firebase configuration
// NOTE: measurementId is intentionally excluded here to prevent Google Analytics
// cookies from being set before the user consents. Call initializeAnalyticsIfConsented()
// after the user opts in to analytics cookies.

const firebaseConfig = {
  apiKey: 'AIzaSyDVD6ESKFTpn9oRlWI43VRta0TuJOGuekA',
  authDomain: 'critcash.com',
  projectId: 'critcash-45968',
  storageBucket: 'critcash-45968.firebasestorage.app',
  messagingSenderId: '21282262103',
  appId: '1:21282262103:web:8a812cc6f0618ccd09e712',
};

const MEASUREMENT_ID = 'G-7YJ3SWWPWF';

// ... (rest of your file with initializeApp, getAuth, etc.)

// Initialize Firebase
let app;
if (getApps().length === 0) {
  app = initializeApp(firebaseConfig);
} else {
  app = getApp();
}

// Initialize App Check right after initializing the app.
// The "typeof window" check ensures this only runs in a browser environment.
// The instance is exported (null outside a browser) for the CritCast desktop
// bridge, which reads its token (useDesktopAuthBridge); firebase/app-check has
// no getter and a second initializeAppCheck throws.
export const appCheck = typeof window !== 'undefined'
  ? initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LcbupQrAAAAAP2nhzdvbzO0IdDVRdIe8rHRDvNb'),
    isTokenAutoRefreshEnabled: true
  })
  : null;

// Get Auth and Firestore instances
export const auth = getAuth(app);

// Explicit auth persistence — defaults to browserLocalPersistence on web,
// but iOS Safari with Intelligent Tracking Prevention can silently degrade
// to inMemoryPersistence after a cross-domain redirect (e.g. returning
// from Stripe Checkout), which logs the user out. Founder hit this on
// mobile dogfood after a merch purchase. Setting the persistence
// explicitly with a cascading fallback gives us the most durable storage
// available per browser: try indexedDB first (most persistent), fall
// back to localStorage, then in-memory if all else fails. This is fire-
// and-forget; we don't block app init on it.
if (typeof window !== 'undefined') {
  setPersistence(auth, indexedDBLocalPersistence)
    .catch(() => setPersistence(auth, browserLocalPersistence))
    .catch(() => setPersistence(auth, inMemoryPersistence))
    .catch((err) => console.warn('[Firebase] auth persistence setup failed:', err?.message));
}

export const db = getFirestore(app);
// Callable Functions instance (default region us-central1, matching the
// deployed onCall functions). Several screens import { functions } from here;
// without this export it resolved to undefined and httpsCallable(functions,…)
// threw "Cannot read properties of undefined (reading '_url')" — which blocked
// the Discord/Twitch OAuth-URL callables on the signup wizard.
export const functions = getFunctions(app);
// The initialized app instance — some screens (e.g. ActiveMatches) import it
// directly for getFunctions(app, region). Was previously unexported (undefined).
export { app };

// ---------------------------------------------------------------------------
// Analytics — only initialized after cookie consent
// ---------------------------------------------------------------------------
let analyticsInstance = null;

export function initializeAnalyticsIfConsented(consent) {
  if (analyticsInstance) return analyticsInstance; // already initialized
  if (!consent?.analytics) return null;            // user did not consent

  try {
    // Dynamically import to avoid loading the analytics SDK before consent
    const { getAnalytics, isSupported } = require('firebase/analytics');
    isSupported().then((supported) => {
      if (supported) {
        // Re-init app config with measurementId now that user consented
        app.options.measurementId = MEASUREMENT_ID;
        analyticsInstance = getAnalytics(app);
      }
    });
  } catch (e) {
    console.log('[Firebase] Analytics init skipped:', e.message);
  }
  return analyticsInstance;
}